import { Box, Switch, Typography } from "@mui/material";

interface ExcludeFromReportToggleProps {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
}

const ExcludeFromReportToggle = ({
  label,
  checked,
  onChange,
}: ExcludeFromReportToggleProps) => {
  return (
    <Box display='flex' alignItems='center' justifyContent='space-between'>
      <Typography>{label} <sup>&#9432;</sup></Typography>
      <Switch
        checked={checked}
        onChange={(event) => onChange(event.target.checked)}
      />
    </Box>
  );
};

export default ExcludeFromReportToggle;
